var notiModal;
var notiCount = 0;

// on edit this item button click
$('body').on('click', '.showNotiBtn', function(e){
	e.preventDefault();
	
	getNotifications(function(data){
		var retHtml = htmlNotifications(data);
			
		notiModal = new window.Popup('<span class="notiCount">' + notiCount + '</span> Notifications', retHtml);
		notiModal.open();
		updateDateTime();
	});
		
	return false;
});

$('body').on('click', '.delNotiBtn', function(e){
	e.preventDefault();
	
	var href 	 = $(this).attr('href');
	var formdata = new FormData();
	var hldEl	 = $(this).parents('.notiHld');
	formdata.append('_method', 'DELETE');

	axios.post(href, formdata)
		.then(function (response) {
			if(response.data.status == 'ok'){
				hldEl.fadeOut('fast', function(){
					hldEl.remove();
					notiCount--;
					$('.notiCount').html(notiCount);
					
					if(notiCount == 0){
						notiModal.close();
					}else{
					}
				});
			}
		})
		.catch(function (error) {
			if(error.response && (error.response.status === 401 || error.response.status === 419)){
				window.location.href = "/login";
			}else{
				var cusalert = new window.cusAlert('Error', 'Could not delete this item.');
				cusalert.open();
			}
		});
});

$('body').on('click', '.delAllNotiBtn', function(e){	
	e.preventDefault();
	
	var href 	 = $(this).attr('href');
	var formdata = new FormData();
	formdata.append('_method', 'DELETE');

	axios.post(href, formdata)
		.then(function (response) {
			if(response.data.status == 'ok'){
				$('.notiHld').fadeOut('fast', function(){
					$('.notiHld').remove();
					notiCount = 0;
					$('.notiCount').html(notiCount);
					notiModal.close();
					
				});
			}
		})
		.catch(function (error) {
			if(error.response && (error.response.status === 401 || error.response.status === 419)){
				window.location.href = "/login";
			}else{
				var cusalert = new window.cusAlert('Error', 'Could not delete these items.');
				cusalert.open();
			}
		});
});

function getNotifications(callback = null){
	axios.get('/notifications')
		.then(function (response) {
			notiCount = response.data.length;
			$('.notiCount').html(notiCount);
			
			if(callback){
				callback(response.data);
			}
		})
}


function htmlNotifications(data){
	var retHtml = '<div class="notiList">';
	
	data.forEach(function(item, index){ 
		retHtml += '<div class="notiHld" data-id="' + item.id + '">';
		retHtml += '	<h3>' + item.data.title + '</h3>';
		retHtml += '	<div class="noti_detail">' + item.created_at + '</div>';
		retHtml += '	<div class="noti_options">';
		retHtml += '		<a href="' + item.data.action + '" title="View device"><img src="/img/icons/clr/24/view.png" alt="View"></a>';
		retHtml += '		<a href="/notifications/' + item.id + '" class="delNotiBtn" title="Delete notification"><img src="/img/icons/clr/24/delete.png" alt="Delete notification"></a>';
		retHtml += '	</div>';
		retHtml += 		item.data.message;
		retHtml += '</div>';
	});
	retHtml += '</div>';
	
	if(data.length > 2){
		retHtml += '<div class="popupBtnBar"><button href="/notifications/deleteall" class="delAllNotiBtn warn">Delete all</button></div>';
	}

	
	return retHtml;
}


window.syncNotifications = function(){
	getNotifications(function(data){
		if($('.pop_content .notiList').length && $('.pop_content .notiList .notiHld').length < data.length){
			$('.pop_content').html(htmlNotifications(data));
			updateDateTime();
		}
	});
}
/* end notifications */